/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_EyebrowInputs */

const tr_landing_telegram_eyebrow = /** @type {(inputs: Landing_Telegram_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`telegram · uzaktan kontrol`)
};

const en_landing_telegram_eyebrow = /** @type {(inputs: Landing_Telegram_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`telegram · remote control`)
};

const de_landing_telegram_eyebrow = /** @type {(inputs: Landing_Telegram_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`telegram · Fernsteuerung`)
};

const ru_landing_telegram_eyebrow = /** @type {(inputs: Landing_Telegram_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`telegram · удаленное управление`)
};

/**
* | output |
* | --- |
* | "telegram · remote control" |
*
* @param {Landing_Telegram_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_eyebrow = /** @type {((inputs?: Landing_Telegram_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_eyebrow(inputs)
	if (locale === "de") return de_landing_telegram_eyebrow(inputs)
	if (locale === "ru") return ru_landing_telegram_eyebrow(inputs)
	return tr_landing_telegram_eyebrow(inputs)
});